// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__yddvY","wrapper":"Section_wrapper__zc80Q","spin":"Section_spin__9oxGb","loader":"Section_loader__pnrDQ"};